import { DatePicker } from "@mui/lab";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Tooltip as Tp,
  debounce,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { getCategories } from "api/services/categories";
import { getClients, getTaskCreateClients, getTaskCreateClientsNew, getTaskCreateClientDropDown} from "api/services/clients/clients";
import { getServices } from "api/services/services";
import { getUsersForReport } from "api/services/users";
import { getOrganization } from "api/services/organization";
import Loader from "components/Loader";
import { usePermissions } from "context/PermissionsProvider";
import {
  NonRecurringFields,
  PriorityEnum,
  RecurringFields,
} from "data/constants";
import { IState } from "pages/settings/bulk-activity/recurring-profile-bulk-activity";
import { useCallback, useMemo, useRef, useState } from "react";
import { useQuery } from "react-query";
import { ResType } from "types";
import { getTitle } from "utils";
import { Permissions } from "data/permissons";
import { mulitipleClient, primaryclient } from "assets";
import { snack } from "components/toast";
import CampaignIcon from "@mui/icons-material/Campaign";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import VirtualizedListboxComponent from "views/billing/invoices/AddInvoice/VirtualizedList";
import clearFilterss from "./../../../assets/images/clear-filter.svg";


interface Props {
  state: IState;
  initialState: IState;
  setState: (state: IState) => void;
  onSubmit: () => void;
  isloading: boolean;
  clearFilters: () => void;
  setData: (data) => void;
  handleViewMore: () => void;
}

enum RecurringFrequency {
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
  HALF_YEARLY = "half_yearly",
  YEARLY = "yearly",
}

function Filters({ state, setState, isloading, onSubmit, clearFilters, handleViewMore, setData, initialState }: Props) {
  const { data, isLoading }: ResType = useQuery(["users"], getUsersForReport);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(0);
  const [clientsList, setClientsList] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number | null>(null);
  const listboxRef = useRef<HTMLUListElement | null>(null);
  const [search, setSearch] = useState("");

  // const { data: clients, isLoading: clientsLoading }: ResType = useQuery(
  //   ["clients"],
  //   getTaskCreateClients,
  // );

  const { data: clients, isLoading: clientsLoading, isFetching }: ResType = useQuery(
    [
      "clients",
      {
        search: debouncedSearch,
        page,
        limit: 10,
      },
    ],
    // getTaskCreateClientsNew,
    getTaskCreateClientDropDown,
    {
      keepPreviousData: true,
      onSuccess: (data) => {
        const newClients = data?.data?.result || [];
        const isNewSearch = page === 0;

        const unique = Array.from(
          new Map([...(!isNewSearch ? clientsList : []), ...newClients].map((item) => [item.id, item])).values()
        );

        setClientsList(unique);
        setTotalCount(data?.data?.totalCount ?? null);

        setTimeout(() => {
          if (listboxRef.current && !isNewSearch) {
            listboxRef.current.scrollTop = listboxRef.current.scrollTop;
          }
        }, 0);
      },
    }
  );

  const { data: services, isLoading: serviceLoading }: ResType = useQuery(
    ["services", {}],
    getServices
  );

  const { data: categories }: ResType = useQuery("categories", getCategories);
  const { data: organization, isLoading: organizationLoading }: ResType = useQuery(
    ["organization"],
    getOrganization
  );
  let { permissions, role } = usePermissions();

  const isPermission = (name) => {
    if (role?.defaultRole) {
      return true;
    }
    if (Array.isArray(name)) {
      let isPermitted = name.some((item) => permissions.includes(item));
      return isPermitted ? true : false;
    }
    if (permissions.includes(name)) {
      return true;
    }
    return false;
  };

  const getSubCategories = categories?.data?.find(
    (item: any) => item.id === state.category?.id
  )?.subCategories;

  const taskPriorityOptions = Object.keys(PriorityEnum).map((key) => ({
    label: key
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()),
    value: PriorityEnum[key],
  }));

  const debouncedFn = useMemo(
    () => debounce((val: string) => setDebouncedSearch(val), 0),
    []
  );

  const handleInputChange = useCallback(
    (value: string, reason: string) => {
      if (reason === "input" || reason === "clear") {
        setSearch(value);
        debouncedFn(value);
        setState({ ...state, client: null });
        setPage(0);
        if (page != 0) {
          setClientsList([]);
        }

      }
    },
    [debouncedFn]
  );
  const handleScroll = (event: React.SyntheticEvent) => {
    if (state.client) return;
    const listboxNode = event.currentTarget as HTMLUListElement;
    listboxRef.current = listboxNode;

    if (
      listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 10 &&
      !isFetching
    ) {
      setPage((prev) => prev + 1);
    }
  };


  if (isLoading || clientsLoading || serviceLoading || organizationLoading) return <Loader />;

  return (
    <Paper sx={{ mt: 1, p: 2, py: 2 }}>
      <Grid container spacing={2}>

        {/* CLIENT */}
        <Grid item xs={4}>
          {/* <Autocomplete
            disablePortal
            value={state.client}
            onChange={(e, v: any) => {
              setState({ ...state, client: v })
              setData(null);
            }
            }
            options={clients?.data?.result || []}
            getOptionLabel={(option: any) => option?.displayName}
            renderInput={(params) => <TextField {...params} size="small" label="Client / Client Group *" />}
            renderOption={(props, option) =>
              option.type ? (
                <li
                  {...props}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography>
                    {option?.displayName}
                    <img
                      src={mulitipleClient}
                      width={"22px"}
                      style={{ marginLeft: "10px", marginRight: "10px" }}
                      alt="group"
                    />
                  </Typography>
                </li>
              ) : (
                <li {...props}>{option?.displayName}</li>
              )
            }
          /> */}
          <Autocomplete
            sx={{ mb: 2 }}
            clearOnEscape
            clearOnBlur={false}
            options={clientsList}
            getOptionLabel={(option) => option.displayName || ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            loading={clientsLoading}
            loadingText="Loading clients..."
            onInputChange={(event, value, reason) => handleInputChange(value, reason)}
            value={clientsList.find((client) => client.id === state?.client?.id) || null}
            onChange={(e, v: any) => {
              setState({ ...state, client: v })
              setData(null);
            }
            }
            ListboxComponent={VirtualizedListboxComponent}
            ListboxProps={{
              onScroll: handleScroll,
              style: {
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              },
            }}
            disableListWrap
            noOptionsText={clientsLoading || isFetching ? <CircularProgress size={60} /> : 'No options'}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Client / Client Group *"
                fullWidth
                size="small"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {(clientsLoading || isFetching) ? <CircularProgress color="inherit" size={30} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
            renderOption={(props, option) => (
              <li {...props} style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography>
                  {option.displayName}

                  {option.type ? (
                    <img
                      src={mulitipleClient}
                      width="22px"
                      style={{ marginLeft: "10px", marginRight: "10px" }}
                      alt="group"
                    />
                  ) : option.isPrimary ? (
                    <img
                      src={primaryclient}
                      width="22px"
                      style={{ marginLeft: "10px", marginRight: "10px" }}
                      alt="primary"
                    />
                  ) : null}
                </Typography>

              </li>
            )}
          />
        </Grid>

        {/* ASSIGNEE */}
        <Grid item xs={4}>
          <Autocomplete
            disablePortal
            value={state.members}
            onChange={(e, v: any) => {
              setState({ ...state, members: v })
              setData(null);
            }
            }
            options={data?.data}
            getOptionLabel={(option: any) => option?.fullName}
            renderInput={(params) => <TextField {...params} size="small" label="Assignee *" />}
          />
        </Grid>

        {/* TASK LEADER */}
        <Grid item xs={4}>
          <Autocomplete
            disablePortal
            value={state.taskLeader}
            onChange={(e, v: any) => {
              setState({ ...state, taskLeader: v })
              setData(null);
            }
            }
            options={["NA", ...data?.data]}
            getOptionLabel={(option: any) => option?.fullName || "NA"}
            renderInput={(params) => <TextField {...params} size="small" label="Task Leader *" />}
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            disablePortal
            value={state.partner}
            onChange={(e, v: any) => {
              setState({ ...state, partner: v })
              setData(null);
            }
            }
            options={data?.data || []}
            getOptionLabel={(option: any) =>
              option?.status === "INACTIVE" ? `${option?.fullName} (Inactive)` : option?.fullName || ""
            }
            renderInput={(params) => <TextField {...params} size="small" label="Partner" />}
          />
        </Grid>
        {/* Approval User */}
        <Grid item xs={4}>
          <Autocomplete
            disablePortal
            value={state.approvalUser}
            onChange={(e, v: any) => {
              setState({ ...state, approvalUser: v })
              setData(null);
            }
            }
            options={["NA", ...data?.data]}
            getOptionLabel={(option: any) => option?.fullName || "NA"}
            renderInput={(params) => <TextField {...params} size="small" label="Approval User *" />}
          />
        </Grid>

        {/* Service Category */}
        <Grid item xs={4}>
          <Autocomplete
            disablePortal
            value={state.category}
            onChange={(e, v: any) => {
              setState({ ...state, category: v });
              setData(null);
            }}
            options={categories?.data || []}
            getOptionLabel={(option: any) => option?.name}
            renderInput={(params) => (
              <TextField {...params} size="small" label="Service Category" />
            )}
          />
        </Grid>
        {getSubCategories?.length > 0 && (
          <Grid item xs={4}>
            <Autocomplete
              disablePortal
              value={state.subCategory}
              onChange={(e, v: any) => {
                setState({ ...state, subCategory: v })
                setData(null);
              }
              }
              options={getSubCategories || []}
              getOptionLabel={(option: any) => option?.name}
              renderInput={(params) => (
                <TextField {...params} size="small" label="Service Sub-Category" />
              )}
            />
          </Grid>
        )}
        {/* SERVICE NAME */}
        <Grid item xs={4}>
          <Autocomplete
            disablePortal
            value={state.service}
            onChange={(e, v: any) => {
              setState({ ...state, service: v })
              setData(null);
            }
            }
            options={services?.data?.result || []}
            getOptionLabel={(option: any) => option?.name}
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {option.name}
              </li>
            )}
            renderInput={(params) => <TextField {...params} size="small" label="Service Name" />}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="Frequency"
            select
            size="small"
            fullWidth
            value={state.frequency}
            onChange={(e) => {
              setState({ ...state, frequency: e.target.value })
              setData(null);
            }}
          >
            {Object.values(RecurringFrequency).map((item) => (
              <MenuItem key={item} value={item}>
                {getTitle(item)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* PRIORITY */}
        <Grid item xs={4}>
          <Autocomplete
            disablePortal
            multiple
            value={state.priority || []}
            onChange={(e, v: any) => {
              const uniqueValues = Array.from(new Set(v.map((item) => item.value))).map((value) =>
                v.find((item) => item.value === value)
              );
              setState({ ...state, priority: uniqueValues });
              setData(null);
            }}
            options={taskPriorityOptions}
            getOptionLabel={(option: any) => option.label}
            renderInput={(params) => <TextField {...params} size="small" label="Task Priority" />}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            select
            label="Billing Type"
            fullWidth
            size="small"
            name="billingType"
            value={state.billingType}
            onChange={(e: any) => {
              setState({ ...state, billingType: e.target.value });
            }}
          >
            <MenuItem value="ALL">ALL</MenuItem>
            <MenuItem value="BILLABLE">Billable</MenuItem>
            <MenuItem value="NON_BILLABLE">Non-Billable</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={3}>
          <TextField
            select
            label="Task Service Type"
            fullWidth
            size="small"
            name="billingType"
            value={state.taskServiceType}
            onChange={(e: any) => {
              setState({ ...state, taskServiceType: e.target.value });
            }}
          >
            <MenuItem value="ALL">ALL</MenuItem>
            <MenuItem value="STANDARD">Standard</MenuItem>
            <MenuItem value="CUSTOM">Custom</MenuItem>
          </TextField>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="space-between" alignItems='center'>
        <Button
          onClick={onSubmit}
          disabled={isloading}
          color="secondary"
          variant="contained"
          sx={{ mt: 2, mb: 2 }}
        >
          Generate Upcoming Non Recurring Tasks
        </Button>
        <Box display='flex' justifyContent='space-between'>
          <Grid item xs={2}>
            {/* <Button
              onClick={clearFilters}
              sx={{ marginLeft: "10px", padding: "6px", marginRight: "6px" }}
              size="small"
              color="secondary"
              variant="outlined"
            >
              Reset Filters
            </Button> */}
            <Tooltip title={'Reset Filters'}>
              <img
                src={clearFilterss}
                alt="Export"
                style={{ cursor: 'pointer', width: 38, height: 38, marginRight: "5px", marginLeft: "5px" }}
                onClick={clearFilters}
              />
            </Tooltip>
            {/* <Button onClick={() => setOpenInfo(true)} variant="outlined">
              <CampaignIcon />
            </Button> */}
          </Grid>
        </Box>
      </Box>

      <Grid container spacing={2}>
        {(isPermission(Permissions.VIEW_ALL_TASKS) ||
          (isPermission(Permissions.VIEW_ASSIGNED_TASKS) && isPermission(Permissions.EDIT_TASK))) && (
            <Grid item xs={4}>
              <TextField
                select
                label="Select Task Field"
                fullWidth
                size="small"
                name="selectedField"
                value={state.selectedField}
                onChange={(e: any) => {
                  if (e.target.value === "update_dates") {
                    if (!state.frequency) {
                      return snack.error("For Update Dates Please Select Frequncy !");
                    } else {
                      setState({
                        ...state,
                        selectedField: e.target.value,
                        newValue: null,
                        existingValue: null,
                        newPartner: null,
                      });
                    }
                  } else {
                    setState({
                      ...state,
                      selectedField: e.target.value,
                      newValue: null,
                      existingValue: null,
                      newTaskLeaders: [],
                      newMembers: [],
                      newPartner: null,
                    });
                  }
                }}
              >
                {NonRecurringFields.map((item) => (
                  <MenuItem key={item.label} value={item.value}>
                    {item.label}
                    {item.value === "update_user" && <Tp title={<span>Assignee can only be updated if no budgeted hours have been allocated to the Recurring Profile. Even then, if you want to update the assignee, you can use the next field, "Update 1 User with Another."</span>}
                      sx={{ cursor: 'pointer', }}>
                      <HelpOutlineIcon fontSize="small" sx={{ marginLeft: "6px" }} />
                    </Tp>}
                    {item.value === "update_new_with_existing_user" && <Tp title={<span>If you update/replace an assignee, their budgeted hours will also be transferred to the new assignee. But if the new assignee is already in the Recurring Profile, the budgeted hours will be added to their current total.</span>}
                      sx={{ cursor: 'pointer', }}>
                      <HelpOutlineIcon fontSize="small" sx={{ marginLeft: "6px" }} />
                    </Tp>}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
      </Grid>
    </Paper>
  );
}

export default Filters;
